import { FC, useState } from "react";
import { TextField, useForm } from "@refinedev/antd";
import { AppViewCard } from "../../../../../components";
import { errorNotification, successNotification } from "../../../../../helpers";
import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Form, Input, Space } from "antd";
import s from "./Clubs-Change-Email.module.scss";
import { ClubsDeleteEntity } from "../Clubs-Delete-Entity/Clubs-Delete-Entity";

type ClubsChangeColorProps = {
  leagueId: number;
  teamId: number;
  email: {
    value: string;
    id: number | null;
  };
  onRefetchCard: () => void;
};

export const ClubsChangeEmail: FC<ClubsChangeColorProps> = ({
  teamId,
  leagueId,
  email,
  onRefetchCard,
}) => {
  const [edit, setEdit] = useState(false);
  const { formProps, saveButtonProps, form, formLoading } = useForm<{
    url: string;
  }>({
    action: email ? "edit" : "create",
    resource: "clubs",
    meta: {
      teamId,
      leagueId,
    },
    dataProviderName: "clubsEmailDataProvider",
    redirect: false,
    ...successNotification({
      successData: {
        message: email ? "Email изменено" : "Email добавлено",
        type: "success",
      },
      callback: () => {
        setEdit(false);
        onRefetchCard();
      },
    }),
    ...errorNotification({}),
  });

  const handleEdit = () => {
    setEdit(true);
  };

  const handleStopEdit = () => {
    setEdit(false);
    form.setFieldValue("value", email.value);
  };

  const handleRefetchOnDelete = () => {
    onRefetchCard();
    form.setFieldValue("value", null);
  };

  if (!email) {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          gap: 16,
        }}
      >
        <Form
          style={{
            width: "100%",
            display: "flex",
            alignItems: "flex-start",
            gap: 8,
          }}
          {...formProps}
          initialValues={{
            teamId,
            leagueId,
          }}
          layout={"vertical"}
        >
          <Form.Item name={"teamId"} hidden />
          <Form.Item name={"leagueId"} hidden />
          <Form.Item
            name={"value"}
            label={"Email:"}
            style={{ width: "100%" }}
            rules={[
              {
                required: true,
                message: "Необходимо указать email",
              },
              {
                max: 1000,
                min: 5,
                message: "Не более 1000 символов и не менее 5 символов",
              },
            ]}
          >
            <Input placeholder={"Укажите email"}></Input>
          </Form.Item>
          <Button className={s.button} type={"primary"} htmlType={"submit"}>
            Добавить email
          </Button>
        </Form>
      </div>
    );
  }

  return (
    <>
      {!edit ? (
        <AppViewCard label={"Email:"}>
          <Space
            direction={"horizontal"}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
            size={24}
          >
            <TextField value={email.value} />
            <div className={s.wrapContainer}>
              <EditOutlined
                style={{
                  fontSize: 20,
                  cursor: "pointer",
                  color: "var(--accent-main)",
                }}
                onClick={handleEdit}
              />
              <ClubsDeleteEntity
                onRefetch={handleRefetchOnDelete}
                deleteId={{ leagueId, teamId }}
                message={"Email успешно удален"}
                okText={"Удалить Email"}
                modalText={"Вы уверены, что хотите удалить email?"}
                dataProviderName={"clubsEmailDataProvider"}
              />
            </div>
          </Space>
        </AppViewCard>
      ) : (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            gap: 16,
          }}
        >
          <Form
            style={{
              width: "100%",
              display: "flex",
              gap: 8,
            }}
            {...formProps}
            initialValues={{
              id: email.id,
              value: email.value,
            }}
            layout={"horizontal"}
          >
            <Form.Item name={"id"} hidden />
            <Form.Item
              name={"value"}
              style={{ width: "100%" }}
              rules={[
                {
                  required: true,
                  message: "Необходимо указать email",
                },
                {
                  min: 3,
                  max: 50,
                  message: "Email может быть от 3 до 50 символов",
                },
              ]}
            >
              <Input placeholder={"Укажите email"}></Input>
            </Form.Item>
            <Button type={"primary"} htmlType={"submit"}>
              Изменить email
            </Button>
            <div className={s.iconContainer}>
              <CloseOutlined
                style={{
                  fontSize: 20,
                  cursor: "pointer",
                  color: "var(--accent-main)",
                }}
                onClick={handleStopEdit}
              />
            </div>
          </Form>
        </div>
      )}
    </>
  );
};
